import { useState, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import up from "../../images/LandingPageImage/up.svg";
import down from "../../images/LandingPageImage/down.svg";
import address from "../../images/LandingPageImage/marker-02.svg";
import call from "../../images/LandingPageImage/phone-call-01.svg";
import email from "../../images/LandingPageImage/globe-03.svg";

// Using forwardRef correctly: props first, then ref
const FAQSection = forwardRef(({ country }, ref) => {
  const [openIndex, setOpenIndex] = useState(0);
  const handleToggle = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <>
      {/* lightweight responsive helpers */}
      <style>{`
        .faq-container { margin: 0 10rem; padding: 5rem 0; gap: 2rem; }
        .faq-left { border: 1px solid #ccc; border-radius: 10px; flex: 5; }
        .faq-right { border-radius: 10px; flex: 4; }
        .faq-icon-img { height: 50px; width: 50px; }
        .faq-tile { border-radius: 10px; }
        .faq-qh { cursor: pointer; }
        @media (max-width: 1200px){
          .faq-container { margin: 0 6rem; }
        }
        @media (max-width: 992px){
          .faq-container { flex-direction: column; margin: 0 2rem; padding: 3rem 0; }
          .faq-left, .faq-right { flex: none; width: 100%; }
        }
        @media (max-width: 576px){
          .faq-container { margin: 0 1rem; padding: 2rem 0; }
        }
      `}</style>

      <div ref={ref} className="d-flex bg-white justify-content-center faq-container">
        {/* FAQs */}
        <div className="p-3 faq-left">
          <ToastContainer />
          <div className="text-center text-2-2 py-4 text-dark-blue-color">FAQs</div>

          <div className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 0 ? "faq-gray-bg" : ""}`}>
            <div
              className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center faq-qh"
              onClick={() => handleToggle(0)}
            >
              <div className="ps-0">What is WhatsApp Automation?</div>
              <div className="p-2">
                {openIndex === 0 ? <img src={up} alt="collapse" height={10} /> : <img src={down} alt="expand" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 0 ? "open" : ""}`}>
              <hr />
              <div className="pt-2">
                WhatsApp Automation involves using software to automate messaging and communication on WhatsApp. It helps streamline business processes such as Customer Support, Promotional Messages, and Reminders by automating repetitive tasks. Implementing WhatsApp Automation can save Time and Resources, Improve Response Times, and Enhance Customer Satisfaction.
              </div>
            </div>
          </div>

          <div className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 1 ? "faq-gray-bg" : ""}`}>
            <div
              className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center faq-qh"
              onClick={() => handleToggle(1)}
            >
              <div className="ps-0">What is Bulk Messaging on WhatsApp?</div>
              <div className="p-2">
                {openIndex === 1 ? <img src={up} alt="collapse" height={10} /> : <img src={down} alt="expand" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 1 ? "open" : ""}`}>
              <hr />
              <div className="pt-2">
                WhatsApp Bulk Messaging allows you to send a large number of messages to multiple recipients simultaneously. Our platform AkaSoft facilitates this process by integrating with WhatsApp API, enabling you to Compose your Message, Select your Recipients, and Schedule or Send the message instantly. It's an efficient way to reach a wide audience quickly and effectively.
              </div>
            </div>
          </div>

          <div className={`faq-item border-bottom-5-css p-4 my-1 border-15-only ${openIndex === 2 ? "faq-gray-bg" : ""}`}>
            <div
              className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center faq-qh"
              onClick={() => handleToggle(2)}
            >
              <div className="ps-0">Is WhatsApp Bulk Messaging legal and compliant with WhatsApp terms of service?</div>
              <div className="p-2">
                {openIndex === 2 ? <img src={up} alt="collapse" height={10} /> : <img src={down} alt="expand" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 2 ? "open" : ""}`}>
              <hr />
              <div className="pt-2">
                Yes, our platform ensures compliance with WhatsApp terms of service and legal regulations regarding bulk messaging. We strictly adhere to WhatsApp guidelines, ensuring that messages are sent only to opted-in recipients who have consented to receive communications from your business. Additionally, we provide features such as Message Templates and Message Scheduling to enhance compliance and improve the user experience.
              </div>
            </div>
          </div>

          <div className={`faq-item p-4 my-1 border-15-only ${openIndex === 3 ? "faq-gray-bg" : ""}`}>
            <div
              className="faq-question text-3-2-dark-dark d-flex justify-content-between align-items-center faq-qh"
              onClick={() => handleToggle(3)}
            >
              <div className="ps-0">Can I Automate Messages on WhatsApp?</div>
              <div className="p-2">
                {openIndex === 3 ? <img src={up} alt="collapse" height={10} /> : <img src={down} alt="expand" height={10} />}
              </div>
            </div>
            <div className={`faq-answer ${openIndex === 3 ? "open" : ""}`}>
              <hr />
              <div className="pt-2">
                Yes, you can easily Automate WhatsApp Messages using the WhatsApp Business App or WhatsApp Business API. The WhatsApp Business App allows Automation of Welcome and Away Messages, while the API enables automation of common customer queries and notifications such as order confirmations and payment reminders.
              </div>
            </div>
          </div>
        </div>

        {/* Contacts */}
        <div className="px-4 py-4 justify-content-between d-flex flex-column button-light-css faq-right">
          <div className="text-white">
            <div className="text-center text-2-2 py-4 text-white">Contact Us</div>
            <p className="text-center text-white">
              Unleash Quality Leads, Nurture, and Interact through WhatsApp after Clicks!
            </p>
          </div>

          <div className="d-flex flex-column gap-4 mb-4">
            <div className="d-flex gap-4 flex-column flex-md-row">
              {/* Chat to Support */}
              <div className="bg-light d-flex flex-column justify-content-center align-items-center p-3 border-15-only faq-tile" style={{ flex: 1 }}>
                <div className="d-flex justify-content-center p-3 border-radius-5 my-2">
                  <img loading="lazy" src={email} alt="Email" className="faq-icon-img" />
                </div>
                <div className="text-3-2 text-light-blue-color text-center">Chat to Support</div>
                <p className="text-center pt-2">
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=support@AkaSoft.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    support@AkaSoft.com
                  </a>
                </p>
              </div>

              {/* Call Us */}
              <div className="bg-light d-flex flex-column justify-content-center align-items-center p-3 border-15-only faq-tile" style={{ flex: 1 }}>
                <div className="d-flex justify-content-center p-3 border-radius-5 my-2">
                  <img loading="lazy" src={call} alt="Call" className="faq-icon-img" />
                </div>
                <div className="text-3-2 text-light-blue-color text-center">Call Us</div>
                <p className="text-center pt-2 text-black">
                  {country === "IN" ? <>+91-9958853167</> : <>+1 (732) 310-0621</>}
                </p>
              </div>
            </div>

            {/* Visit Us */}
            <div className="bg-light d-flex flex-column justify-content-center align-items-center p-3 border-15-only faq-tile">
              <div className="d-flex justify-content-center p-3 border-radius-5 my-2">
                <img loading="lazy" src={address} alt="Address" className="faq-icon-img" />
              </div>
              <div className="text-3-2 text-light-blue-color text-center">Visit Us</div>
              <p className="text-center pt-2 px-3 text-black">
                {country === "IN" ? (
                  <>Ithum Tower, Tower-B, 218, Second Floor, Sector 62, Noida-201309</>
                ) : (
                  <>3807 S 7TH ST, Phoenix AZ 85040</>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default FAQSection;
